import { useEffect, useState } from 'react'

// Types
import { ImplantReportStatus, Option } from 'common/types'
import {
  ImplantReportSenderProps,
  NewImplantReportEmailInput,
} from './ImplantReportSender.types'

// Hooks
import { useIsMobile } from 'lib/utils/mediaQueries'
import { useGetOrganizationReports } from 'lib/services/api/email-service/getOrganizationReports.ts'

export const useImplantReportSenderLogic = (
  props: ImplantReportSenderProps
) => {
  const { assetGroups, surgeryId, implantReportStatus, provider } = props

  // Services
  const { data: reportsData, isLoading: isLoadingReports } =
    useGetOrganizationReports(surgeryId)

  // States
  const isMobile = useIsMobile()
  const assetIds = assetGroups.flatMap((item) =>
    item.scans
      .filter(
        (item) =>
          item.assetType === 'biological' ||
          item.assetType === 'non-biological' ||
          item.assetType === 'other-non-biological'
      )
      .map((scan) => scan._id)
  )
  const [inputModalOpen, setInputModalOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()
  const [mutationSuccess, setMutationSuccess] = useState<boolean>()
  const [isReportSent, setIsReportSent] = useState(false)
  const [viewReportsModalOpen, setViewReportsModalOpen] = useState(false)
  const [implantReportInputs, setImplantReportInputs] =
    useState<NewImplantReportEmailInput>({
      referringPhysicianEmail: provider?.emailAddresses[0],
      referringPhysicianLastName: provider?.lastName,
      surgeryId,
      reportType: undefined,
      physicianId: undefined,
      reportInputs: {
        assetIds,
      },
      submitOverride: false,
    })

  const disabledOption = (option: string | Option) => {
    const opt = typeof option === 'object' ? option.name : option
    const enumType = opt
    if (option === 'Other') {
      return false
    } else {
      return !(implantReportStatus as ImplantReportStatus[]).some(
        (status) => status.type === enumType && status.isSent
      )
    }
  }

  useEffect(() => {
    if (implantReportStatus) {
      setIsReportSent(implantReportStatus.some((status) => status.isSent))
    }
  }, [implantReportStatus])

  return {
    reports: reportsData?.reports.map((report) => ({
      id: report.id,
      name: report.name,
    })),
    isMobile,
    assetIds,
    isLoading: isLoadingReports,
    errorMessage,
    isReportSent,
    inputModalOpen,
    mutationSuccess,
    implantReportInputs,
    viewReportsModalOpen,
    disabledOption,
    setErrorMessage,
    setInputModalOpen,
    setMutationSuccess,
    setImplantReportInputs,
    setViewReportsModalOpen,
  }
}
